import { memo, useCallback } from 'react'

import { Divider, SvgIcon } from '@mui/material'
import { SmepWorkspaceRoleRamInvitation } from '@nativewaves/nw-cloud-sdk/smep'
import { PlugDisconnected } from 'emotion-icons/fluentui-system-filled'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemConfirm, MenuItemCopyId } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useWorkspaceInvitationDeleteMutation } from 'hooks/mutations/smep'
import { workspaceSettingsPermissionsInvitationsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Settings'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<SmepWorkspaceRoleRamInvitation>) => {
  const { t } = useTranslation(['common', 'entity', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { workspaceId } = workspaceSettingsPermissionsInvitationsRoute.useParams()

  const { id, recipientEmail } = row.original

  const { mutate: cancelInvitation } = useWorkspaceInvitationDeleteMutation()

  const handleDeleteMember = useCallback(() => {
    onClose()

    cancelInvitation(
      { workspaceId, invitationId: id },
      {
        onError: () =>
          enqueueSnackbar(t('success.entityDelete', { entity: recipientEmail }), {
            variant: 'error',
          }),
      },
    )
  }, [onClose, cancelInvitation, workspaceId, id, enqueueSnackbar, t, recipientEmail])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemConfirm
        onConfirm={handleDeleteMember}
        staticLabel={t('domain:Workspace.Dashboard.removeInvitation')}
        startIcon={
          <SvgIcon color="error">
            <PlugDisconnected />
          </SvgIcon>
        }
        ConfirmTypographyProps={{ color: 'error' }}
      />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
